import React, { Component } from 'react';

import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Growl } from 'primereact/growl';
import { Lightbox } from 'primereact/lightbox';

import { Archivo } from '../componentes/Archivo';
import { obtenerBytesBase64Archivos } from '../servicio/ServicioLecturaArchivos';
import servicioObjetos from '../servicio/ServicioObjetos';
import servicioHttp from '../servicio/ServicioHttp';
import servicioArchivos from '../servicio/ServicioArchivos';
import { Dialog } from 'primereact/dialog';
import forge from 'node-forge';
import servicioFormatos from '../servicio/ServicioFormatos';
import { DEFAULT_MASKS } from '../servicio/ServicioConstantes';
import { validacionCertificadosDigitales } from '../servicio/ServicioValidacionCertificadosDigitales';
import servicioGeneradorAnios from '../servicio/ServicioGeneradorAnios';

const VALOR_REQUERIDO = "Dato requerido";

const ERRORES_INICIAL = {
}
const JOIN_PRINCIPAL = {
    "ttPatron": "alias_ttPatron"

};
export class AltaRegistroPatronal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            registroPatronal: {},
            error: {},
            datosSeleccionados: [],
            areas: [
                { label: "Área - A", value: "ÁREA A" },
                { label: "Área - B", value: "ÁREA B" },
                { label: "Área - C", value: "ÁREA C" },
            ],
            meses: [
                { label: "Enero", value: "Enero" },
                { label: "Febrero", value: "Febrero" },
                { label: "Marzo", value: "Marzo" },
                { label: "Abril", value: "Abril" },
                { label: "Mayo", value: "Mayo" },
                { label: "Junio", value: "Junio" },
                { label: "Julio", value: "Julio" },
                { label: "Agosto", value: "Agosto" },
                { label: "Septiembre", value: "Septiembre" },
                { label: "Octubre", value: "Octubre" },
                { label: "Noviembre", value: "Noviembre" },
                { label: "Diciembre", value: "Diciembre" }
            ],
            anios: servicioGeneradorAnios.generarAnios()
            ,
            clases: [
                { label: "I - Ordinario", value: "I" },
                { label: "II - Bajo", value: "II" },
                { label: "III - Medio", value: "III" },
                { label: "IV - Alto", value: "IV" },
                { label: "V - Máximo", value: "V" },
            ],
            stypss: [
                { label: "No", value: "No" },
                { label: "Si", value: "Si" }
            ],
            tipos: [
                { label: "Certificado Digital", value: 1 },
                { label: "FIEL", value: 2 }],
            tipo: null,
            mostrarArchivos: true,
            indexDatos: null,
            fracciones: [],
            delegaciones: [],
            subdelegaciones: [],
            patrones: [],
            fecha: {},
            iFrameSrc: null,
            listaPrimaRiesgo: [],
            convenioReembolso: false,
            paginacion: { registrosPorPagina: 10 },
            modalEliminar: false,
            esEditar: false,
            idsenube: 0,
            objetoFecha: {},
            actualizar: false,
            archivos: null,
            erroresContrasena: {},
            modalCertificado: false,
            erroresCarga: {},
            esPfx: false,
            esFiel: false,
            opcion: {},
            registros: {},
            modalEliminarPrima: false

        }
    }

    /************************************** Agregar Registro Patronal**********************************/

    componentDidMount() {
        this.consultarPatron();
    }

    consultarPatron = () => {
        let patrones = [];
        servicioHttp.consumirPostHttp("patron/consultar_patron.json").then((response) => {
            let data = response.data.objeto.datos;
            data.map((item) => {
                patrones.push({ label: item.nombreComercial + " - " + item.rfc, value: item.id, });
                return null;//Se agrega esta columna ya que se debe de retornar algo aqui pero no es necesario
            });
            this.setState({ patrones: patrones });
        }).catch(() => { });
    }

    consultarRegistroPatronal = () => {
        let { registroPatronal, registros, paginacion } = this.state;
        paginacion.join = JOIN_PRINCIPAL;
        paginacion.restriccionesDinamicas = [
            {
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttPatron.id",
                valorPropiedad: registroPatronal.patron
            }
        ];
        servicioHttp
            .consumirPostHttp("/registropatronal/paginacion.json", paginacion)
            .then((response) => {
                this.setState({ paginacion: response.data.objeto });
                let datos = response.data.objeto;
                registros.id = datos.id;
                if (response.data.mensaje !== null) {
                    this.growl.show({ severity: 'success', summary: 'Aviso', detail: response.data.mensaje });
                }

            })
            .catch(() => { });
    }

    /**
     * Método que permite obtener el valor seleccionado por los dropdown 
     * (municipio, delegacion, subdelegación, clase y fracción).
     * 
     * @param {*} event 
     * @param {*} mayusculas 
     */
    asignarValor = (event, mayusculas) => {
        let { esEditar } = this.state;
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
        let id = event.target.id;
        let valor = event.target.value;
        let valores = event.target.value.value;
        let { registroPatronal, opcion } = this.state;
        if (id === "registroPatronal.codigoPostal") {
            this.consultarEntidad(valor, registroPatronal);
            this.consultarDelegacion(valor, registroPatronal);
        }

        if (id === "registroPatronal.delegacion") {
            registroPatronal.claveSubdelegacion = null;
            this.consultarDelegacion(valores, registroPatronal);
            this.consultarSubdelegacion(valores, registroPatronal);
        }

        if (id === "registroPatronal.subdelegacion") {
            this.consultarClaveSubdelegacion(valores, registroPatronal);
        }

        if (id === "registroPatronal.clase") {
            let valores = null;
            if (!esEditar) {
                valores = event.target.value;
            }/*  */
            if (esEditar) {
                valores = event.target.value;
            }

            this.cargarFraccion(valores);
        }

        if (id === "registroPatronal.patron") {
            this.seleccionarPatron(valor, registroPatronal);
            this.consultarRegistroPatronal();
        }
        if (id === "opcion.valor") {
            if (opcion.valor.value === 2) {
                this.setState({ esFiel: true, esPfx: false });
            }
            if (opcion.valor.value === 1) {
                this.setState({ esPfx: true, esFiel: false });
            }
        }
    };

    /**
     * Método que permite crear una lista con los datos requeridos para generar el reporte en Excel
     * y PDF del histórico de Primas de Riesgo en en Trabajo del Registro Patronal.
     */
    agregarPrimaRiesgoTrabajo = () => {
        let error = {};
        let { registroPatronal, listaPrimaRiesgo } = this.state;
        if (servicioObjetos.esObjetoVacio(registroPatronal.meses) ||
            servicioObjetos.esObjetoVacio(registroPatronal.anios) ||
            servicioObjetos.esObjetoVacio(registroPatronal.prima)) {
            error.meses = "Seleccione Mes";
            error.anios = "Seleccione Año";
            error.prima = "Proporcione Prima";
        } else {
            let mensajeValidacion = "El formato es invalido debe de ser 0.00000";
            var primaValido = /^(\d{1})(.)(\d{5})$/;
            var validacionPrima = primaValido.exec(registroPatronal.prima);
            if (!validacionPrima) {
                error.prima = mensajeValidacion;
            }
            if (servicioObjetos.esObjetoVacio(error)) {
                let primaRiesgo = {
                    mes: registroPatronal.meses,
                    anio: registroPatronal.anios,
                    prima: registroPatronal.prima
                };
                delete registroPatronal.meses;
                delete registroPatronal.anios;
                delete registroPatronal.prima;
                listaPrimaRiesgo.push(primaRiesgo);
                this.setState({
                    listaPrimaRiesgo: listaPrimaRiesgo,
                    registroPatronal: registroPatronal
                });
            }

        }
        this.setState({ error: error });
    }

    asignaValor = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
        this.setState({ archivos: this });
    };

    /**
     * Método para obtener el código postal y llenar el campo de entidad (clave del estado y el estado).
     * Obtiene los municipios en base a la clave del estado.
     * 
     * @param {*} codigoPostal 
     * @param {*} registroPatronal 
     */
    consultarEntidad = (codigoPostal, registroPatronal) => {
        if (codigoPostal.length >= 2) {
            let valor = codigoPostal.substring(0, 2);
            servicioHttp.consumirPostHttp("/claveentidad/obtener_cp.json", { codigoPostalAsentamiento: valor }).then(response => {
                let claveEntidad = response.data.objeto;
                registroPatronal.entidad = claveEntidad.claveEstado + " " + claveEntidad.estado;
                this.obtenerMunicipios(claveEntidad.claveEstado).then(responseMunicipios => {
                    if (servicioObjetos.esObjetoVacio(registroPatronal.id)) {
                        registroPatronal.poblacion = null;
                    } else {
                        let valorPoblacion = registroPatronal.poblacion;
                        registroPatronal.poblacion = { value: valorPoblacion, label: valorPoblacion }
                    }

                    this.setState({
                        registroPatronal: registroPatronal,
                        municipios: responseMunicipios.data.lista
                    });
                }).catch(error => {

                });
            }).catch(error => {

            });
        } else {
            registroPatronal.entidad = null;
            registroPatronal.poblacion = null;
            this.setState({
                registroPatronal: registroPatronal,
                municipios: []
            });
        }
    }


    /**
    * Método para obtener la clave del estado en base al código postal.
    * 
    * @param {*} codigoPostal 
    * @param {*} registroPatronal 
    */
    consultarDelegacion = (codigoPostal, registroPatronal) => {
        if (codigoPostal.length >= 2) {
            let valor = codigoPostal.substring(0, 2);
            servicioHttp.consumirPostHttp("/claveentidad/obtener_cp.json", { codigoPostalAsentamiento: valor }).then(response => {
                let claveEntidad = response.data.objeto;
                this.obtenerDelegacion(claveEntidad.claveEstado).then(responseDelegaciones => {
                    this.setState({ delegaciones: responseDelegaciones.data.lista });
                    if (servicioObjetos.esObjetoVacio(registroPatronal.id)) {
                        registroPatronal.delegacion = null;
                    } else {
                        let valorDelegacion = registroPatronal.delegacion;
                        registroPatronal.delegacion = { value: valorDelegacion, label: valorDelegacion }
                    }
                    this.setState({ registroPatronal: registroPatronal });
                }).catch(error => {
                });
            }).catch(error => {

            });
        } else {
            registroPatronal.delegacion = null;
            this.setState({
                registroPatronal: registroPatronal,
                delegaciones: []
            });
        }
    }


    /**
     * Método para obtener las delegaciones en base a la clave del estado.
     * 
     * @param {*} claveEstado 
     * @returns 
     */
    obtenerDelegacion = (claveEstado) => {
        return new Promise(function (resolve, reject) {
            servicioHttp.consumirPostHttp('delegaciones/obtener_delegaciones.json', { claveEstado: claveEstado }).then(response => {
                resolve(response);
            }).catch(error => {
                reject("error");
            });
        });
    }

    /**
     * Método que obtiene las delegaciones para obtener las subdelegaciones que le pertenecen.
     * 
     * @param {*} delegacion 
     * @param {*} registroPatronal 
     */
    consultarSubdelegacion = (delegacion, registroPatronal) => {
        let valor = delegacion;
        servicioHttp.consumirPostHttp('delegaciones/consulta_subdelegaciones.json', { delegacion: valor }).then(response => {
            this.setState({ subdelegaciones: response.data.lista });
            if (servicioObjetos.esObjetoVacio(registroPatronal.id)) {
                registroPatronal.subdelegacion = null;
            } else {
                let valorSubdelegacion = registroPatronal.subdelegacion;
                registroPatronal.subdelegacion = { value: valorSubdelegacion, label: valorSubdelegacion }
            }
            this.setState({ registroPatronal: registroPatronal });
        }).catch(error => {
        });
    }

    /**
     * Método que permite obtener la clave de la subdelegación y poder llebar el campo clave subdelegación,
     * en base a la subdelegación seleccionada.
     * @param {*} subdelegacion 
     * @param {*} registroPatronal 
     */
    consultarClaveSubdelegacion = (subdelegacion, registroPatronal) => {
        let valor = subdelegacion;
        servicioHttp.consumirPostHttp("delegaciones/obtener_clave.json", { subdelegacion: valor }).then(response => {
            let clave = response.data.objeto;
            registroPatronal.claveSubdelegacion = clave.claveSubdelegacion;
            this.setState({ registroPatronal: registroPatronal });
        }).catch(error => {

        });
    }

    /**
     * Método que permite obtener las fracciónes de acuerdo a las clases que le corresponden.
     * 
     * @param {*} clase 
     * @param {*} registroPatronal 
     */
    cargarFraccion = (clase) => {
        let valor = clase;
        servicioHttp.consumirPostHttp("fraccion/consultar_fracciones.json", { clase: valor }).then(response => {
            this.setState({ fracciones: response.data.lista });
            // console.log(response.data.lista);
            // if (servicioObjetos.esObjetoVacio(registroPatronal.id)) {
            //     //registroPatronal.clase = registroPatronal.clase;
            // } else {
            //     let valorClase = registroPatronal.clase;
            //     registroPatronal.clase = { value: valorClase, label: valorClase }
            // }
            // this.setState({ registroPatronal: registroPatronal });
        }).catch(error => {
        });
    }

    /**
     * Método que cargar los archivos seleccionados para Certificado DIgital o FIEL.
     * 
     * @param {*} event 
     */
    cargarArchivo = (event) => {
        obtenerBytesBase64Archivos(event, this);
    }

    /**
    * Método que permite crear un checkbox dentro de la tabla histórico de Primas de Riesgo en el Trabajo.
    * 
    * @param {Método} rowData 
    * @param {*} column 
    * @returns 
    */
    plantillaChecBoxDatos = (rowData, column) => {
        return <Checkbox inputId="cb2" value={rowData} onChange={this.validarRegistrosDatos} checked={this.state.datosSeleccionados.indexOf(rowData) !== -1} ></Checkbox>
    }

    /**
    * Método que valida la selección de una fila en la tabla Primas de Riesgos en el Trabajo del
    * Registro Patronal.
    * 
    * @param {*} e 
    */
    validarRegistrosDatos = (e) => {
        let { datosSeleccionados } = this.state;
        if (e.checked) {
            datosSeleccionados.push(e.value);
        } else {
            servicioObjetos.eliminarObjetoMapa(datosSeleccionados, e.value);
        }
        this.setState({ datosSeleccionados: datosSeleccionados });
    }

    /**
   * Método que elimina la prima seleccionada de la tabla Primas de Riesgo en el Trabajo del
   * Registro Patronal.
   */
    eliminarDelaListaCaptura = () => {
        let { listaPrimaRiesgo, datosSeleccionados } = this.state;
        let copiaSeleccionados = [...datosSeleccionados];
        for (let contador = 0; contador < copiaSeleccionados.length; contador++) {
            let elemento = copiaSeleccionados[contador];
            servicioObjetos.eliminarObjetoMapa(listaPrimaRiesgo, elemento);
            servicioObjetos.eliminarObjetoMapa(datosSeleccionados, elemento);

            servicioHttp.consumirPostHttp("registropatronal/eliminar_prima.json", elemento).then(response => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                this.cerrarModalEliminarPrima();
            }).catch(error => {
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
            })

        }
    }

    /**
     * Método que permite visualizar y/o ocultar la contraseña ingresada para el Certificado Digital.
     */
    mostrarContrasenaPFX = () => {
        var cambio = document.getElementById("registroPatronal.contraseniaPfx");
        if (cambio.type === "password") {
            cambio.type = "text";
        } else {
            cambio.type = "password";
        }
    }

    /**
     * Método que permite visualizar y/o ocultar la contraseña ingresada para el certificado FIEL.
     */
    mostrarContrasenaFiel = () => {
        var cambio = document.getElementById("registroPatronal.contraseniaFiel");
        if (cambio.type === "password") {
            cambio.type = "text";
        } else {
            cambio.type = "password";
        }
    }

    /**
    * Método para obtener la razón social(nombre) y el RFC del patrón seleccionado.
    * 
    * @param {*} patron 
    * @param {*} registroPatronal 
    */
    seleccionarPatron(patron, registroPatronal) {
        let valor = patron;
        servicioHttp.consumirPostHttp("patron/consulta_patrones_rp.json", { id: valor }).then(response => {
            let data = response.data.objeto;
            registroPatronal.nombre = data.nombre;
            registroPatronal.rfc = data.rfc;
            //this.consultarRegistroPatronal();
        }).catch(error => {

        });
    }


    /**
    * Método para guardar un nuevo Registro Patronal.
    */
    guardarRegistroPatronal = () => {
        try {
            let { registroPatronal, listaPrimaRiesgo, objetoFecha } = this.state;
            let error = this.validarFormularioRP(registroPatronal, false);
            this.setState({ error: error });
            if (servicioObjetos.esObjetoVacio(error)) {
                if (listaPrimaRiesgo.length === 0)
                    throw new Error("Debes de agregar almenos una prima de riesgo de trabajo");
                let objetoWrapper = this.obtenerObjetoClaseWrapperReportes();
                const validacionPfx = this.validarCertificadoPfx(registroPatronal);
                this.setState({ erroresContrasena: validacionPfx });
                if (!Object.keys(validacionPfx).length) {

                    registroPatronal.fechaExpiracion = objetoFecha.fecha;

                    objetoWrapper.ttRegistroPatronal.fechaExpiracion = registroPatronal.fechaExpiracion.getTime();
                    servicioHttp.consumirPostHttp('registropatronal/guardar.json', objetoWrapper).then(response => {
                        this.growl.show({ severity: response.data.error ? 'error' : 'success', summary: response.data.error ? 'Error' : 'Éxito', detail: response.data.mensaje });
                        this.limpiarPantalla();
                        let { guardarRegistroPatronal } = this.props;
                        guardarRegistroPatronal(response);

                    }).catch(error => {
                        this.growl.show({ severity: 'error', summary: 'Error', detail: 'Registro patronal duplicado' });
                    });
                }
            }
        } catch (error) {
            this.growl.show({ severity: 'error', summary: 'Aviso', detail: error.message, life: 3000 });
        }
    }

    guardarRegistroPatronalFiel = () => {
        try {
            let { registroPatronal, listaPrimaRiesgo } = this.state;
            let error = this.validarFormularioRP(registroPatronal, false);
            this.setState({ error: error });
            if (servicioObjetos.esObjetoVacio(error)) {
                if (listaPrimaRiesgo.length === 0)
                    throw new Error("Debes de agregar almenos una prima de riesgo de trabajo");
                let objetoWrapper = this.obtenerObjetoClaseWrapperReportes();
                try {
                    let validacionCertificado = validacionCertificadosDigitales(registroPatronal.certificadoCer, registroPatronal.certificadoKey, registroPatronal.contraseniaFiel, registroPatronal.rfc, "FIEL");
                    objetoWrapper.ttRegistroPatronal.fechaExpiracion = validacionCertificado.fechaFinal.getTime();
                    objetoWrapper.ttRegistroPatronal.fechaCreacion = validacionCertificado.fechaInicial.getTime();

                    servicioHttp.consumirPostHttp('registropatronal/guardar.json', objetoWrapper).then(response => {
                        this.growl.show({ severity: response.data.error ? 'error' : 'success', summary: response.data.error ? 'Error' : 'Éxito', detail: response.data.mensaje });
                        this.limpiarPantalla();
                        let { guardarRegistroPatronal } = this.props;
                        guardarRegistroPatronal(response);

                    }).catch(error => {
                        this.growl.show({ severity: 'error', summary: 'Error', detail: 'Registro patronal duplicado' });
                    });
                } catch (error) {
                    this.growl.show({ severity: 'error', summary: 'Error', detail: "El certificado que intenta validar no corresponde al rfc de emisor", life: 10000 });
                }
            }
        } catch (error) {
            this.growl.show({ severity: 'error', summary: 'Aviso', detail: error.message, life: 3000 });
        }
    }

    /**
    * Método que valida que se llenen todos los campos que son obligatorios, para agregar
    * un nuevo Registro Patronal.
    * 
    * @param {*} registroPatronal 
    * @returns 
    */
    validarFormularioRP = (registroPatronal, exportarArchivos) => {
        let { tipo } = this.state;

        let error = JSON.parse(JSON.stringify(ERRORES_INICIAL));
        if (servicioObjetos.esObjetoVacio(registroPatronal.registroPatronal))
            error.registroPatronal = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.nombreCorto))
            error.nombreCorto = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.representanteLegal))
            error.representanteLegal = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.actividadEconomica))
            error.actividadEconomica = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.calle))
            error.calle = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.codigoPostal)) {
            error.codigoPostal = VALOR_REQUERIDO;
        } else {
            if (registroPatronal.codigoPostal.length !== 5)
                error.codigoPostal = "La longitud del código postal debe de ser de 5 carácteres";
        }
        if (servicioObjetos.esObjetoVacio(registroPatronal.entidad))
            error.entidad = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.poblacion))
            error.poblacion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.telefono))
            error.telefono = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.areaGeografica))
            error.area = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.delegacion))
            error.delegacion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.claveSubdelegacion))
            error.claveSubdelegacion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.subdelegacion))
            error.subdelegacion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.mesAfiliacion))
            error.mesAfiliacion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.anioAfiliacion))
            error.anioAfiliacion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.clase))
            error.clase = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.fraccion))
            error.fraccion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.styps))
            error.styps = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.patron))
            error.patron = VALOR_REQUERIDO;


        if (!exportarArchivos) {
            if (servicioObjetos.esObjetoVacio(tipo))
                error.tipo = VALOR_REQUERIDO;
            if (tipo === 1) {
                if (servicioObjetos.esObjetoVacio(registroPatronal.usuario))
                    error.usuario = VALOR_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(registroPatronal.certificadoPfx))
                    error.certificadoPfx = VALOR_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(registroPatronal.contraseniaPfx))
                    error.contraseniaPfx = VALOR_REQUERIDO;
            } else if (tipo === 2) {

                if (servicioObjetos.esObjetoVacio(registroPatronal.certificadoCer))
                    error.certificadoCer = VALOR_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(registroPatronal.certificadoKey))
                    error.certificadoKey = VALOR_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(registroPatronal.contraseniaFiel))
                    error.contraseniaFiel = VALOR_REQUERIDO;
            }
        }
        return error;
    }


    validarFormularioActualizar = (registroPatronal) => {


        let error = JSON.parse(JSON.stringify(ERRORES_INICIAL));
        if (servicioObjetos.esObjetoVacio(registroPatronal.registroPatronal))
            error.registroPatronal = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.nombreCorto))
            error.nombreCorto = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.representanteLegal))
            error.representanteLegal = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.actividadEconomica))
            error.actividadEconomica = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.calle))
            error.calle = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.codigoPostal)) {
            error.codigoPostal = VALOR_REQUERIDO;
        } else {
            if (registroPatronal.codigoPostal.length !== 5)
                error.codigoPostal = "La longitud del código postal debe de ser de 5 carácteres";
        }
        if (servicioObjetos.esObjetoVacio(registroPatronal.entidad))
            error.entidad = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.poblacion))
            error.poblacion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.telefono))
            error.telefono = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.areaGeografica))
            error.area = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.delegacion))
            error.delegacion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.claveSubdelegacion))
            error.claveSubdelegacion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.subdelegacion))
            error.subdelegacion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.mesAfiliacion))
            error.mesAfiliacion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.anioAfiliacion))
            error.anioAfiliacion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.clase))
            error.clase = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.fraccion))
            error.fraccion = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.styps))
            error.styps = VALOR_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(registroPatronal.patron))
            error.patron = VALOR_REQUERIDO;
        return error;
    }

    /**
     * Método que crea el reporte en Excel del histórico de Primas de Riesgo en el Trabajo.
     */
    exportExcel = () => {
        try {
            let { registroPatronal, listaPrimaRiesgo } = this.state;
            let error = this.validarFormularioRP(registroPatronal, true);
            this.setState({ error: error });
            if (servicioObjetos.esObjetoVacio(error)) {
                if (listaPrimaRiesgo.length === 0)
                    throw new Error("Debes de agregar almenos una prima de riesgo de trabajo");
                let objetoWrapper = this.obtenerObjetoClaseWrapperReportes();
                servicioArchivos.descargaArchivo("registropatronal/reporte_excel_rp.json", objetoWrapper);
            }
        } catch (error) {
            this.growl.show({ severity: 'error', summary: 'Aviso', detail: error.message, life: 3000 });
        }
    }

    obtenerObjetoClaseWrapperReportes = () => {
        let { registroPatronal, listaPrimaRiesgo, convenioReembolso } = this.state;
        let clonRegistroPatronal = { ...registroPatronal };
        clonRegistroPatronal.fraccion = registroPatronal.fraccion;
        clonRegistroPatronal.poblacion = registroPatronal.poblacion.value;
        clonRegistroPatronal.delegacion = registroPatronal.delegacion.value;
        clonRegistroPatronal.subdelegacion = registroPatronal.subdelegacion.value;
        clonRegistroPatronal.clase = registroPatronal.clase;
        let claseWrapper = {};
        let ttPatron = {};
        ttPatron.id = clonRegistroPatronal.patron;
        clonRegistroPatronal.ttPatron = ttPatron;
        delete clonRegistroPatronal['patron'];
        //Los nuevos registros patronales se guardan como "Activo", en este caso con 0
        clonRegistroPatronal.estado = 0;
        clonRegistroPatronal.ttPrimaRiesgoTrabajos = listaPrimaRiesgo;
        clonRegistroPatronal.convenioReembolso = convenioReembolso ? "si" : "no";
        claseWrapper.ttRegistroPatronal = clonRegistroPatronal;
        return claseWrapper;
    }

    /**
     * Método que crea el reporte en PDF del histórico de Primas de Riesgo en el Trabajo.
     */
    exportPDF = () => {
        try {
            let { registroPatronal, listaPrimaRiesgo } = this.state;
            let error = this.validarFormularioRP(registroPatronal, true);
            this.setState({ error: error });
            if (servicioObjetos.esObjetoVacio(error)) {
                if (listaPrimaRiesgo.length === 0)
                    throw new Error("Debes de agregar valores para prima vacacional");
                let objetoWrapper = this.obtenerObjetoClaseWrapperReportes();
                servicioArchivos.descargaArchivoComoBlob('registropatronal/reporte_pdf.json', objetoWrapper).then((response) => {
                    this.setState({ iFrameSrc: URL.createObjectURL(response) });
                    document.getElementById("btnVisorPdfTarget").click();
                }).catch((error) => {
                    this.growl.show({ severity: 'error', summary: 'Error', detail: 'No se encuentra el archivo' });
                });
            }
        } catch (error) {
            this.growl.show({ severity: 'error', summary: 'Aviso', detail: error.message, life: 3000 });
        }
    }

    obtenerMunicipios = (claveEstado) => {
        return new Promise(function (resolve, reject) {
            servicioHttp.consumirPostHttp('/municipioalcaldia/obtener_estado.json', { claveEstado: claveEstado }).then(response => {
                resolve(response);
            }).catch(error => {
                reject("error");
            });
        });
    }

    mostrarModalEliminar = (objeto) => {
        let { registroPatronal } = this.state;
        registroPatronal.id = objeto.id;
        this.setState({ modalEliminar: true, registroPatronal });
    }

    cerrarModalEliminar = () => {
        this.setState({ modalEliminar: false });
        this.consultarRegistroPatronal();
    }

    eliminarRP = () => {
        let { registroPatronal } = this.state;
        servicioHttp
            .consumirPostHttp("registropatronal/eliminar.json", { id: registroPatronal.id })
            .then((response) => {
                this.setState({ modalEliminar: false });
                this.limpiarPantalla();
                this.growl.show({
                    severity: response.data.error === false ? "success" : "error",
                    summary: "",
                    detail: response.data.mensaje,
                });
            })
            .catch(() => { });
    }

    plantillaOpciones = (rowData, column) => {
        return <div className="p-grid">

            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.actualizar(rowData)}
                    className="p-button-warning" name="Editar" tooltip="Editar">
                </Button>
            </div>
            <div className="p-col-12 p-md-4">
                <Button
                    type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminar(rowData)}
                    className="p-button-danger" name="Eliminar" tooltip="Eliminar">
                </Button>
            </div>
            <div className="p-col-12 p-md-4">
                <Button
                    type="button" icon="pi-md-save" onClick={(e) => this.mostrarModalCertificado(rowData)}
                    className="p-button-success" name="Cargar certificado" tooltip="Cargar Certificado">
                </Button>
            </div>

        </div>;
    }

    actualizar = (rowData) => {
        let registroPatronal = JSON.parse(JSON.stringify(rowData));
        servicioHttp.consumirPostHttp('registropatronal/listado_prima_riesgo_trabajo.json', { id: registroPatronal.id }).then(response => {

            // let area=areas.filter(area=>{   
            //         return area.value===registroPatronal.areaGeografica;     
            // });
            // registroPatronal.areaGeografica=area[0];

            this.consultarEntidad(rowData.codigoPostal, registroPatronal);
            this.consultarDelegacion(rowData.codigoPostal, registroPatronal);

            this.consultarSubdelegacion(rowData.delegacion, registroPatronal);
            this.consultarClaveSubdelegacion(rowData.subdelegacion, registroPatronal);
            this.cargarFraccion(registroPatronal.clase);
            registroPatronal.patron = registroPatronal.idPatron;

            this.setState({ resgistroPatronal: registroPatronal, listaPrimaRiesgo: response.data.lista });
            this.setState({ esEditar: true });

        }).catch(error => {
        })
    }

    actualizarRegistroPatronal = () => {
        let { registroPatronal } = this.state;
        let error = this.validarFormularioActualizar(registroPatronal);
        this.setState({ error: error });
        if (servicioObjetos.esObjetoVacio(error)) {
            let objetoWrapper = this.obtenerObjetoClaseWrapperReportes();
            servicioHttp.consumirPostHttp('registropatronal/guardar.json', objetoWrapper).then(response => {
                this.growl.show({ severity: response.data.error ? 'error' : 'success', summary: response.data.error ? 'Error' : 'Éxito', detail: response.data.mensaje });
                this.consultarRegistroPatronal();
                this.limpiarPantalla();
            }).catch(error => {
                this.growl.show({ severity: 'error', summary: 'Error', detail: 'Existe un error no esperado al actualizar el registro Patronal' });
            });
        }

    }

    onIndexTemplate = (data, props) => {
        let { idsenube } = this.state;
        return (props.rowIndex + 1) + idsenube;
    }

    formatoEstado = (rowData) => {
        if (rowData.estado === 0)
            return <p style={{ backgroundColor: '#33ff4c', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Activo</p>;
        if (rowData.estado === 1)
            return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Inactivo</p>;
    }

    formatoFecha = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fechaExpiracion)}</div>;
    }

    mostrarModalCertificado = (objeto) => {
        let { registroPatronal } = this.state;
        registroPatronal.id = objeto.id;
        this.setState({ modalCertificados: true, registroPatronal });
    }

    cerrarModalCertificado = () => {
        this.setState({ modalCertificados: false });
    }

    guardarCargaCertificado = () => {
        let { registroPatronal, objetoFecha } = this.state;

        const validacion = this.validarFormularioCarga(registroPatronal);
        this.setState({ erroresCarga: validacion });
        if (!Object.keys(validacion).length) {
            const validacionPfx = this.validarCertificadoPfx(registroPatronal);
            this.setState({ erroresContrasena: validacionPfx });
            if (!Object.keys(validacionPfx).length) {
                registroPatronal.fechaExpiracion = objetoFecha.fecha;
                registroPatronal.fechaExpiracion = registroPatronal.fechaExpiracion.getTime();
                servicioHttp.consumirPostHttp('registropatronal/actualizar_certificados.json', registroPatronal).then(response => {
                    this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                    this.cerrarModalCertificado();
                }).catch(error => {
                    this.growl.show({ severity: 'error', summary: 'Error', detail: 'Existe un error no esperado al actualizar certificado' });
                    this.cerrarModalCertificado();
                });
            }
        }
    }

    validarCertificadoPfx = (objetoEmpresa) => {
        let { objetoFecha } = this.state;
        const errores = {};
        var p12Der = forge.util.decode64(objetoEmpresa.certificadoPfx);
        var p12Asn1 = forge.asn1.fromDer(p12Der);
        let p12 = null;
        try {
            p12 = forge.pkcs12.pkcs12FromAsn1(p12Asn1, objetoEmpresa.contraseniaPfx);
            var bags = p12.getBags({ bagType: forge.pki.oids.certBag });
            var certificado2 = bags[forge.pki.oids.certBag][1];
            objetoFecha.fecha = certificado2.cert.validity.notAfter;
            this.setState({ objetoFecha });
        } catch (e) {
            errores.contraseniaPfx = "La contraseña del archivo .pfx es incorrecta";
            this.growl.show({ severity: 'error', summary: 'Error', detail: errores.contraseniaPfx, life: 10000 });
        }
        return errores;
    }

    validarFormularioCarga = (objeto) => {
        const errores = {};
        if (servicioObjetos.esObjetoVacio(objeto.usuario))
            errores.usuario = "Campo requerido";
        if (servicioObjetos.esObjetoVacio(objeto.contraseniaPfx))
            errores.contraseniaPfx = "Campo requerido";
        if (servicioObjetos.esObjetoVacio(objeto.certificadoPfx))
            errores.certificadoPfx = "Campo requerido";

        return errores;
    }

    /**
     * Método que permite limpiar todos los campos que conforman la vista.
     */
    limpiarPantalla = () => {
        this.setState({
            idsenube: 0,
            registroPatronal: {},
            error: {},
            delegaciones: [],
            subdelegaciones: [],
            mostrarArchivos: false,
            tipo: [],
            datosSeleccionados: [],
            convenioReembolso: false,
            esEditar: false,
            listaPrimaRiesgo: []

        });
        setTimeout(() => {
            this.setState({ mostrarArchivos: true });
        }, 50);
    }

    reset = () => {
        this.setState({
            modalUsuario: {},
            archivos: null,
            error: {},
            erroresCarga: {},
            registroPatronal: {},
            tipo: [],
            paginacion: { registrosPorPagina: 10 }
        });
    }

    mostrarModalEliminarPrima = (objeto) => {
        this.setState({ modalEliminarPrima: true });
    }

    cerrarModalEliminarPrima = () => {
        this.setState({ modalEliminarPrima: false });
    }

    render() {
        const { registroPatronal, error, municipios, delegaciones, subdelegaciones,
            datosSeleccionados, fracciones, tipo, mostrarArchivos,
            patrones, areas, tipos, iFrameSrc, listaPrimaRiesgo, convenioReembolso,
            meses, anios, clases, stypss, esEditar, paginacion, modalEliminar, erroresCarga, modalCertificados, modalEliminarPrima } = this.state;

        let archivoPfx =
            <div className="p-col-12 p-md-9">
                <Archivo id="registroPatronal.certificadoPfx" nombre="registroPatronal.certificadoPfx" value={registroPatronal.certificadoPfx} etiqueta="Seleccionar Archivo" cambio={this.cargarArchivo} aceptar=".pfx" style={{ width: "100%" }} />
                {error.certificadoPfx ? <div><br /> <Message severity="error" text={error.certificadoPfx} /> </div> : null}
            </div>;

        let archivoCer =
            <div className="p-col-12 p-md-9">
                <Archivo id="registroPatronal.certificadoCer" nombre="registroPatronal.certificadoCer" value={registroPatronal.certificadoCer} etiqueta="Seleccionar Archivo" cambio={this.cargarArchivo} aceptar=".cer" style={{ width: "100%" }} />
                {error.certificadoCer ? <div><br /> <Message severity="error" text={error.certificadoCer} /> </div> : null}
            </div>;

        let archivoKey =
            <div className="p-col-12 p-md-9">
                <Archivo id="registroPatronal.certificadoKey" nombre="registroPatronal.certificadoKey" value={registroPatronal.certificadoKey} etiqueta="Seleccionar Archivo" cambio={this.cargarArchivo} aceptar=".key" style={{ width: "100%" }} />
                {error.certificadoKey ? <div><br /> <Message severity="error" text={error.certificadoKey} /> </div> : null}
            </div>;
        const visorPdfTarget = (
            <button id="btnVisorPdfTarget" className="p-link" style={{ visibility: "hidden" }}></button>
        );

        const pieDialogEliminar = (
            <div>
                <Button icon="pi-md-check" onClick={this.eliminarRP} label="Si estoy seguro" />
                <Button icon="pi-md-close" onClick={this.cerrarModalEliminar} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
        );

        const pieDialogoCertificado = (
            <div>
                <Button label="Guardar" icon="pi-md-save" onClick={this.guardarCargaCertificado} />
                <Button label="Cancelar" icon="pi-md-close" onClick={this.cerrarModalCertificado} className="p-button-danger " />
            </div>
        );


        const pieDialogEliminarPrima = (
            <div>
                <Button icon="pi-md-check" onClick={this.eliminarDelaListaCaptura} label="Si estoy seguro" />
                <Button icon="pi-md-close" onClick={this.cerrarModalEliminarPrima} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
        );

        return (
            <div className="card">
                <Lightbox target={visorPdfTarget}>
                    <div id="contenedorIframe"  >
                        <iframe id="elIframe" src={iFrameSrc} frameBorder="0" className="iframeEstilo" title="pdf" ></iframe>
                    </div>
                </Lightbox>
                <Growl ref={(el) => this.growl = el} />
                <div className="p-grid">
                    <div className="p-col-12 p-md-12">
                        <center><h1>Administración de Registro Patronal</h1></center>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label>* Registro Patronal:</label>
                    </div>
                    <div className="p-col-12 p-md-10">
                        <InputText id="registroPatronal.registroPatronal" name="registroPatronal.registroPatronal" placeholder="Registro Patronal" value={registroPatronal.registroPatronal || ""}
                            maxLength="11" keyfilter={DEFAULT_MASKS.alphanum} type="search" style={{ width: "100%" }} onChange={(e) => this.asignaValor(e, true)} />
                        {error.registroPatronal ? <div><Message severity="error" text={error.registroPatronal} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label>* RFC Empresa:</label>
                    </div>
                    <div className="p-col-12 p-md-10">
                        <Dropdown optionValue="value" id="registroPatronal.patron" name="registroPatronal.patron" options={patrones}
                            placeholder="RFC" style={{ width: "100%" }} value={registroPatronal.patron}
                            onChange={(e) => this.asignarValor(e, false)} className={error.patron ? "p-error" : ""} />
                        {error.patron ? <div><Message severity="error" text={error.patron} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-3">
                        <label>* Nombre comercial/corto:</label>
                    </div>
                    <div className="p-col-12 p-md-9">
                        <InputText id="registroPatronal.nombreCorto" name="registroPatronal.nombreCorto" placeholder="Alias" style={{ width: "100%" }}
                            value={registroPatronal.nombreCorto || ""} className={error.nombreCorto ? "p-error" : ""} onChange={(e) => { this.asignarValor(e, true) }}
                            maxLength="25" type="search" />
                        {error.nombreCorto ? <div><Message severity="error" text={error.nombreCorto} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label>* Representante Legal:</label>
                    </div>
                    <div className="p-col-12 p-md-10">
                        <InputText id="registroPatronal.representanteLegal" name="registroPatronal.representanteLegal" placeholder="Nombre" value={registroPatronal.representanteLegal || ""} maxLength="100" keyfilter={DEFAULT_MASKS.alphaspace} type="search" style={{ width: "100%" }} onChange={(e) => this.asignaValor(e, true)} />
                        {error.representanteLegal ? <div><Message severity="error" text={error.representanteLegal} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-3">
                        <label>* Actividad Económica:</label>
                    </div>
                    <div className="p-col-12 p-md-9">
                        <InputText id="registroPatronal.actividadEconomica" name="registroPatronal.actividadEconomica" placeholder="Actividad Económica" style={{ width: "100%" }}
                            value={registroPatronal.actividadEconomica || ""} onChange={(e) => { this.asignaValor(e, true) }} maxLength="100" keyfilter={DEFAULT_MASKS.alphaspace} type="search" />
                        {error.actividadEconomica ? <div><Message severity="error" text={error.actividadEconomica} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label>* Calle No. y Colonia:</label>
                    </div>
                    <div className="p-col-12 p-md-10">
                        <InputText id="registroPatronal.calle" name="registroPatronal.calle" placeholder="Calle No. y Colonia" value={registroPatronal.calle || ""} type="search" maxLength="100" style={{ width: "100%" }} onChange={(e) => this.asignaValor(e, true)} />
                        {error.calle ? <div><Message severity="error" text={error.calle} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label>* Código Postal:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="registroPatronal.codigoPostal" name="registroPatronal.codigoPostal" placeholder="Código postal" style={{ width: "100%" }}
                            value={registroPatronal.codigoPostal || ""} className={error.codigoPostal ? "p-error" : ""} onChange={(e) => { this.asignarValor(e, true) }}
                            maxLength="5" keyfilter="pint" type="search" />
                        {error.codigoPostal ? <div><Message severity="error" text={error.codigoPostal} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label>* Entidad:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="registroPatronal.entidad" name="registroPatronal.entidad" placeholder="Entidad" style={{ width: "100%", 'font-weight': 'bold', color: 'blue' }}
                            value={registroPatronal.entidad || ""} className={error.entidad ? "p-error" : ""} onChange={(e) => { this.asignarValor(e, true) }}
                            disabled={true} type="search" />
                        {error.entidad ? <div><Message severity="error" text={error.entidad} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-3">
                        <label>* Población y Municipio/Alcaldía:</label>
                    </div>
                    <div className="p-col-12 p-md-9">
                        <Dropdown id="registroPatronal.poblacion" name="registroPatronal.poblacion" optionLabel="label" options={municipios} value={registroPatronal.poblacion}
                            onChange={(e) => this.asignarValor(e, false)} autoWidth={false} style={{ width: "100%" }} className={error.poblacion ? "p-error" : ""}
                            placeholder="Seleccione población" />
                        {error.poblacion ? <div><Message severity="error" text={error.poblacion} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label>* Teléfono:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="registroPatronal.telefono" name="registroPatronal.telefono" placeholder="Teléfono" style={{ width: "100%" }}
                            value={registroPatronal.telefono || ""} className={error.telefono ? "p-error" : ""} onChange={(e) => { this.asignaValor(e, true) }}
                            maxLength="10" keyfilter="pint" type="search" />
                        {error.telefono ? <div><Message severity="error" text={error.telefono} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-6">
                        <label>* Convenido de Reembolso de Subsidios:</label>
                        <Checkbox inputId="registroPatronal.convenioReembolso" id="registroPatronal.convenioReembolso" name="registroPatronal.convenioReembolso" value={registroPatronal.convenioReembolso}
                            checked={convenioReembolso} onChange={e => this.setState({ convenioReembolso: e.checked })} />
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label>* Área Geográfica:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Dropdown appendTo={document.body} id="registroPatronal.areaGeografica" name="registroPatronal.areaGeografica" optionValue="value" options={areas}
                            placeholder="Área Geográfica" style={{ width: "100%" }} value={registroPatronal.areaGeografica}
                            onChange={(e) => this.asignaValor(e, false)} className={error.area ? "p-error" : ""} />
                        {error.area ? <div><Message severity="error" text={error.area} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label>* Delegación IMSS:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Dropdown appendTo={document.body} id="registroPatronal.delegacion" name="registroPatronal.delegacion" optionLabel="label" options={delegaciones} value={registroPatronal.delegacion}
                            onChange={(e) => this.asignarValor(e, false)} autoWidth={false} style={{ width: "100%" }} className={error.delegacion ? "p-error" : ""}
                            placeholder="Delegación IMSS" />
                        {error.delegacion ? <div><Message severity="error" text={error.delegacion} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label>* Clave Subdelegación:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="registroPatronal.claveSubdelegacion" name="registroPatronal.claveSubdelegacion" placeholder="Clave Subdelegación" style={{ width: "100%", 'font-weight': 'bold', color: 'blue' }}
                            value={registroPatronal.claveSubdelegacion || ""} className={error.claveSubdelegacion ? "p-error" : ""} onChange={(e) => { this.asignarValor(e, true) }}
                            disabled={true} type="text" />
                        {error.claveSubdelegacion ? <div><Message severity="error" text={error.claveSubdelegacion} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label>* Subdelegación IMSS:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Dropdown appendTo={document.body} id="registroPatronal.subdelegacion" name="registroPatronal.subdelegacion" optionLabel="label" options={subdelegaciones} value={registroPatronal.subdelegacion}
                            onChange={(e) => this.asignarValor(e, false)} autoWidth={false} style={{ width: "100%" }} className={error.subdelegacion ? "p-error" : ""}
                            placeholder="Subdelegación IMSS" />
                        {error.subdelegacion ? <div><Message severity="error" text={error.subdelegacion} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-5">
                        <label>* Mes y año de idsenube del Módulo de Afiliación:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Dropdown appendTo={document.body} id="registroPatronal.mesAfiliacion" name="registroPatronal.mesAfiliacion" options={meses} placeholder="Mes" style={{ width: "100%" }} value={registroPatronal.mesAfiliacion} onChange={(e) => this.asignaValor(e, false)} className={error.mesAfiliacion ? "p-error" : ""} />
                        {error.mesAfiliacion ? <div><Message severity="error" text={error.mesAfiliacion} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-3">
                        <Dropdown appendTo={document.body} id="registroPatronal.anioAfiliacion" name="registroPatronal.anioAfiliacion" options={anios} placeholder="Año" style={{ width: "100%" }} value={registroPatronal.anioAfiliacion} onChange={(e) => this.asignaValor(e, false)} className={error.anioAfiliacion ? "p-error" : ""} />
                        {error.anioAfiliacion ? <div><Message severity="error" text={error.anioAfiliacion} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-12">
                        <center><h1>Clase - Fracción - Prima de Riesgos de Trabajo</h1></center>
                    </div>

                    <div className="p-col-12 p-md-1">
                        <center><label>* Mes:</label></center>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <center><Dropdown appendTo={document.body} id="registroPatronal.meses" name="registroPatronal.meses" options={this.state.meses} placeholder="Mes" style={{ width: "100%" }} value={registroPatronal.meses}
                            onChange={(e) => this.asignaValor(e, false)} className={error.meses ? "p-error" : ""} /></center>
                        {error.meses ? <div><Message severity="error" text={error.meses} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-1">
                        <center><label>* Año:</label></center>
                    </div>
                    <div className="p-col-12 p-md-1">
                        <center><Dropdown appendTo={document.body} id="registroPatronal.anios" name="registroPatronal.anios" options={this.state.anios} placeholder="Año" style={{ width: "100%" }} value={registroPatronal.anios}
                            onChange={(e) => this.asignaValor(e, false)} className={error.anios ? "p-error" : ""} /></center>
                        {error.anios ? <div><Message severity="error" text={error.anios} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-1">
                        <center><label>* Prima:</label></center>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <center><InputText id="registroPatronal.prima" name="registroPatronal.prima" placeholder="0.00000" value={registroPatronal.prima || ""} maxLength="7" style={{ width: "100%" }}
                            onChange={(e) => this.asignaValor(e, true)} className={error.prima ? "p-error" : ""} keyfilter="num" min="0" step="0.50000" /></center>
                        {error.prima ? <div><Message severity="error" text={error.prima} /></div> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <center><Button id="registroPatronal.agregar" label="Agregar" icon="pi-md-plus" onClick={this.agregarPrimaRiesgoTrabajo} style={{ width: "100%" }} /></center>
                    </div>
                    {datosSeleccionados.length > 0 ?
                        <div className="p-col-12 p-md-2">
                            <center><Button label="Eliminar" icon="pi-md-delete" onClick={this.mostrarModalEliminarPrima} style={{ width: "100%" }} /></center>
                        </div> : ""}

                    <div className="p-col-12 p-md-12">
                        <label></label>
                    </div>

                    <div className="p-col-12 p-md-3">
                        <label></label>
                    </div>
                    <div className="p-col-12 p-md-6">
                        <DataTable value={listaPrimaRiesgo} responsive={true}>
                            <Column header="Seleccionar" body={this.plantillaChecBoxDatos} autoLayout={true} resizableColumns={true} />
                            <Column header="Mes" field="mes" autoLayout={true} resizableColumns={true} />
                            <Column header="Año" field="anio" autoLayout={true} resizableColumns={true} />
                            <Column header="Prima" field="prima" autoLayout={true} resizableColumns={true} />
                        </DataTable>
                    </div>

                    <div className="p-col-12 p-md-2">
                        <Button label="Exportar Excel" icon="pi-md-import-export" onClick={this.exportExcel} style={{ width: "100%" }} />
                    </div>
                    <div className="p-col-12 p-md-9">
                        <label></label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Button label="Exportar PDF" icon="pi-md-import-export" onClick={this.exportPDF} style={{ width: "100%" }} />
                    </div>

                    <div className="p-col-12 p-md-12">

                    </div>

                    <div className="p-col-12 p-md-1">
                        <center><label>* Clase:</label></center>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <center><Dropdown id="registroPatronal.clase" name="registroPatronal.clase" optionValue="value" options={clases} value={registroPatronal.clase}
                            onChange={(e) => this.asignarValor(e, false)} autoWidth={false} style={{ width: "100%" }} className={error.clase ? "p-error" : ""}
                            placeholder="Clase" /></center>
                        {error.clase ? <div><Message severity="error" text={error.clase} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-1">
                        <center><label>* Fracción:</label></center>
                    </div>
                    <div className="p-col-12 p-md-6">
                        <center><Dropdown id="registroPatronal.fraccion" name="registroPatronal.fraccion" optionValue="value" options={fracciones} value={registroPatronal.fraccion}
                            onChange={(e) => this.asignarValor(e, false)} autoWidth={false} style={{ width: "100%" }} className={error.fraccion ? "p-error" : ""}
                            placeholder="Fracción" /></center>
                        {error.fraccion ? <div><Message severity="error" text={error.fraccion} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-1">
                        <center><label>* STyPS:</label></center>
                    </div>
                    <div className="p-col-12 p-md-1">
                        <center><Dropdown id="registroPatronal.styps" name="registroPatronal.styps" options={stypss} placeholder="STyPS" style={{ width: "100%" }} value={registroPatronal.styps} onChange={(e) => this.asignaValor(e, false)} /></center>
                        {error.styps ? <div><Message severity="error" text={error.styps} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-12">

                    </div>

                    <div className="p-col-12 p-md-12">

                    </div>

                    <div className="p-col-12 p-md-4">
                        <label></label>
                    </div>
                    {!esEditar ?
                        <div className="p-col-12 p-md-2">
                            <label>* Tipo de Archivo:</label>
                        </div>
                        : null}
                    {!esEditar ?
                        <div className="p-col-12 p-md-3">
                            <Dropdown options={tipos} placeholder="Selecciona una opción" style={{ width: "100%" }} value={tipo} onChange={(event) => this.setState({ tipo: event.value })} />
                            {error.tipo ? <div><Message severity="error" text={error.tipo} /></div> : null}
                        </div>
                        : null}
                    <div className="p-col-12 p-md-3">
                        <label></label>
                    </div>
                    <div className="p-col-12 p-md-12">

                    </div>

                    {tipo === 1 ?
                        <div className="p-col-12 p-md-12">
                            <center><h1>Certificado Digital</h1></center>
                        </div> : ""}

                    {tipo === 1 ?
                        <div className="p-col-12 p-md-12">

                        </div> : ""}

                    {tipo === 1 ?
                        <div className="p-col-12 p-md-3">
                            <label>* Usuario IDSE:</label>
                        </div> : ""}

                    {tipo === 1 ?
                        <div className="p-col-12 p-md-9">
                            <InputText id="registroPatronal.usuario" name="registroPatronal.usuario" value={registroPatronal.usuario || ""} placeholder="Usuario IDSE"
                                type="text" maxLength="200" style={{ width: "100%" }} onChange={(e) => this.asignaValor(e, true)} />
                            {error.usuario ? <div><Message severity="error" text={error.usuario} /></div> : null}
                        </div> : ""}

                    {tipo === 1 ?
                        <div className="p-col-12 p-md-3">
                            <label>* Certificado Digital (.pfx):</label>
                        </div> : ""}

                    {tipo === 1 ?
                        mostrarArchivos ? archivoPfx : null
                        : ""}

                    {tipo === 1 ?
                        <div className="p-col-12 p-md-3">
                            <label>* Contraseña Certificado:</label>
                        </div> : ""}

                    {tipo === 1 ?
                        <div className="p-col-12 p-md-8">
                            <InputText id="registroPatronal.contraseniaPfx" name="registroPatronal.contraseniaPfx" placeholder="Contraseña Certificado" value={registroPatronal.contraseniaPfx || ""}
                                type="password" maxLength="200" style={{ width: "100%" }} onChange={(e) => this.asignaValor(e, false)} />
                            {error.contraseniaPfx ? <div><Message severity="error" text={error.contraseniaPfx} /></div> : null}
                        </div> : ""}

                    {tipo === 1 ?
                        <div className="p-col-12 p-md-1">
                            <Button icon="pi-md-visibility" onClick={this.mostrarContrasenaPFX} />
                        </div> : ""}

                    {tipo === 2 ?
                        <div className="p-col-12 p-md-12">
                            <center><h1>FIEL</h1></center>
                        </div> : ""}

                    {tipo === 2 ?
                        <div className="p-col-12 p-md-12">

                        </div> : ""}

                    {tipo === 2 ?
                        <div className="p-col-12 p-md-3">
                            <label>* Certificado Digital (*.cer):</label>
                        </div> : ""}

                    {tipo === 2 ?
                        mostrarArchivos ? archivoCer : null
                        : ""}

                    {tipo === 2 ?
                        <div className="p-col-12 p-md-3">
                            <label>* Llave privada (.key):</label>
                        </div> : ""}

                    {tipo === 2 ?
                        mostrarArchivos ? archivoKey : null
                        : ""}

                    {tipo === 2 ?
                        <div className="p-col-12 p-md-3">
                            <label>* Contraseña Certificado:</label>
                        </div> : ""}
                    {tipo === 2 ?
                        <div className="p-col-12 p-md-8">
                            <InputText id="registroPatronal.contraseniaFiel" name="registroPatronal.contraseniaFiel" placeholder="Contraseña FIEL" value={registroPatronal.contraseniaFiel || ""}
                                type="password" maxLength="200" style={{ width: "100%" }} onChange={(e) => this.asignaValor(e, false)} />
                            {error.contraseniaFiel ? <div><Message severity="error" text={error.contraseniaFiel} /></div> : null}
                        </div> : ""}
                    {tipo === 2 ?
                        <div className="p-col-12 p-md-1">
                            <Button icon="pi-md-visibility" onClick={this.mostrarContrasenaFiel} />
                        </div> : ""}

                    <div className="p-col-12 p-md-12">
                    </div>

                    <div className="p-col-12 p-md-2">
                        <Button label="Limpiar" icon="pi-md-refresh" onClick={this.limpiarPantalla} style={{ width: "100%" }} />
                    </div>
                    {tipo === 1 ?
                        <div className="p-col-12 p-md-2">
                            <Button label='Guardar' icon='pi-md-save' onClick={this.guardarRegistroPatronal} style={{ width: "100%" }} />
                        </div>
                        : null}

                    {tipo === 2 ?
                        <div className="p-col-12 p-md-2">
                            <Button label='Guardar' icon='pi-md-save' onClick={this.guardarRegistroPatronalFiel} style={{ width: "100%" }} />
                        </div>
                        : null}
                    {esEditar ?
                        <div className="p-col-12 p-md-2">
                            <Button label='Editar' icon='pi-md-edit' onClick={this.actualizarRegistroPatronal} style={{ width: "100%" }} />
                        </div> : null}

                    <div className="p-col-12 p-md-12">
                        
                    </div>

                    <div className="p-col-12 p-md-12">
                        <DataTable value={paginacion.datos} header="Registros Patronales" responsive={true} paginator={true} rows={5}>
                            <Column header="No." body={this.onIndexTemplate} autoLayout={true} style={{ width: "10px" }} />
                            <Column header="Registro Patronal" field="registroPatronal" autoLayout={true} style={{ width: "80px" }} />
                            <Column header="Razón Social" field="nombre" autoLayout={true} style={{ width: "80px" }} />
                            <Column header="Nombre Corto" field="nombreCorto" autoLayout={true} style={{ width: "80px" }} />
                            <Column header="RFC" field="rfc" autoLayout={true} style={{ width: "70px" }} />
                            <Column header="Fecha Expiración" body={this.formatoFecha} autoLayout={true} style={{ width: "60px" }} />
                            <Column header="Estado" body={this.formatoEstado} autoLayout={true} style={{ width: "40px" }} />
                            <Column header="Opciones" body={this.plantillaOpciones} autoLayout={true} style={{ width: "50px" }} />
                        </DataTable>
                    </div>

                    <Dialog style={{ width: '50%', height: '30%' }} header="Eliminar Registro Patronal" visible={modalEliminar} modal={true}
                        footer={pieDialogEliminar} onHide={this.cerrarModalEliminar}>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-12">
                                <center><h2><strong>¿Estás seguro de eliminar este registro?</strong></h2></center>
                            </div>
                        </div>
                    </Dialog>

                    <Dialog style={{ width: '60%', height: '50%' }} visible={modalCertificados} header="Carga de certificado" modal={true}
                        footer={pieDialogoCertificado} onHide={this.cerrarModalCertificado}>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-12">
                                <center><h2><strong>Los campos con (*) son obligatorios, por favor captura los datos de la Empresa.</strong></h2></center>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <label></label>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <label></label>
                            </div>
                            <div className="p-col-12 p-md-12">
                                <label></label>
                            </div>
                            <div className="p-col-12 p-md-6">
                                <span className="md-inputfield">
                                    <InputText type="text" maxLength="200" id="registroPatronal.usuario" name="registroPatronal.usuario" value={registroPatronal.usuario || ""} className={erroresCarga.usuario ? "p-error" : ""} onChange={(e) => { this.asignarValor(e, false) }} style={{ width: "90%" }} />
                                    <label>* Usuario Idse:</label>
                                    {erroresCarga.usuario ? <div><Message severity="error" text={erroresCarga.usuario} /> </div> : null}
                                </span>
                            </div>
                            <div className="p-col-12 p-md-5">
                                <span className="md-inputfield">
                                    <InputText type="password" maxLength="200" id="registroPatronal.contraseniaPfx" name="registroPatronal.contraseniaPfx" value={registroPatronal.contraseniaPfx || ""} className={erroresCarga.contraseniaPfx ? "p-error" : ""} onChange={(e) => { this.asignarValor(e, false) }} style={{ width: "90%" }} />
                                    <label>* Contraseña:</label>
                                    {erroresCarga.contraseniaPfx ? <div><Message severity="error" text={erroresCarga.contraseniaPfx} /> </div> : null}
                                </span>
                            </div>
                            <div className="p-col-12 p-md-1">
                                <Button icon="pi-md-visibility" onClick={this.mostrarContrasenaPFX} />
                            </div>
                            <div className="p-col-12 p-md-12">
                                <div className="p-col-12 p-md-9">
                                    <Archivo id="registroPatronal.certificadoPfx" nombre="registroPatronal.certificadoPfx" etiqueta="Seleccionar Archivo" cambio={this.cargarArchivo} aceptar=".pfx" style={{ width: "100%" }} />
                                    {erroresCarga.certificadoPfx ? <div><br /> <Message severity="error" text={erroresCarga.certificadoPfx} /> </div> : null}
                                </div>
                            </div>
                            <div className="p-col-12 p-md-12">
                                <label></label>
                            </div>
                        </div>
                    </Dialog>
                    <Dialog style={{ width: '50%', height: '30%' }} header="Eliminar Prima de Riesgo de Trabajo" visible={modalEliminarPrima} modal={true}
                        footer={pieDialogEliminarPrima} onHide={this.cerrarModalEliminarPrima}>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-12">
                                <center><h2><strong>¿Estás seguro de eliminar este registro?</strong></h2></center>
                            </div>
                        </div>
                    </Dialog>
                </div>
            </div>
        );
    }
}